/* eslint-disable react-refresh/only-export-components */
import * as React from 'react';
import { type ToasterProps } from 'sonner';
export { toast } from 'sonner';

import { Toaster } from './components/ui/sonner.js';

// Overrides Sonner's richColors palette to match the chip/badge token scale
// (emerald/amber/red at the 50–200 range, same as DimeChip success/warning).
// Merged with --normal-* vars from components/ui/sonner.tsx so neither set
// clobbers the other on the [data-sonner-toaster] element.
const toasterStyle = {
  // theme tokens — keep in sync with components/ui/sonner.tsx
  '--normal-bg': 'var(--popover)',
  '--normal-text': 'var(--popover-foreground)',
  '--normal-border': 'var(--border)',
  '--border-radius': 'var(--radius)',
  // rich color overrides — emerald/amber/red/blue at the 50–200 scale
  '--success-bg': 'rgb(236 253 245)', // emerald-50
  '--success-border': 'rgb(167 243 208)', // emerald-200
  '--success-text': 'rgb(4 120 87)', // emerald-700
  '--warning-bg': 'rgb(255 251 235)', // amber-50
  '--warning-border': 'rgb(253 230 138)', // amber-200
  '--warning-text': 'rgb(146 64 14)', // amber-800
  '--error-bg': 'rgb(254 242 242)', // red-50
  '--error-border': 'rgb(254 202 202)', // red-200
  '--error-text': 'rgb(185 28 28)', // red-700
  '--info-bg': 'rgb(239 246 255)', // blue-50
  '--info-border': 'rgb(191 219 254)', // blue-200
  '--info-text': 'rgb(29 78 216)', // blue-700
} as React.CSSProperties;

/** Classes for a 30rem toast (`toast.custom`'s `className`), re-centred because the toaster centres its own 356px column; on a phone Sonner's full-width rules still win. */
export const DIME_WIDE_TOAST = 'w-[30rem] left-[calc(var(--width)/2_-_15rem)]';

// Wraps the shadcn-generated Toaster, dropping the next-themes dependency.
// Passes all CSS vars in one style prop so --normal-* and --*-bg/border/text
// coexist on the same [data-sonner-toaster] element.
export function DimeToaster({
  theme = 'system',
  position = 'top-center',
  style,
  ...props
}: Readonly<ToasterProps>) {
  return (
    <Toaster theme={theme} position={position} style={{ ...toasterStyle, ...style }} {...props} />
  );
}
